var map = {
	"./but.png": 987,
	"./headphones/headphones_1.png": 275,
	"./headphones/headphones_2.png": 592,
	"./headphones/headphones_3.png": 417,
	"./wireless-headphones/headphones_4.png": 663,
	"./wireless-headphones/headphones_5.png": 998,
	"./wireless-headphones/headphones_6.png": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;